import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"

import {
	resetGetVoucherTransactionList,
	getVoucherTransactionList
} from "../../redux/actions/getVoucherTransactionListAction";

import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const VoucherTransaction = () => {
	const classes = useStyles();
	const navigate = useHistory();
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [trackingId, setTrackingId] = useState("");
	const [paymentId, setPaymentId] = useState("");
	const [customerId, setCustomerId] = useState("");
	const [statusType, setStatusType] = useState("");
	const [transactionType, setTransactionType] = useState("")
	const [fromDateTime, setfromDateTime] = useState("00:00:00");
	const [toDateTime, settoDateTime] = useState("23:59:59");
	const [isLoading, setIsLoading] = useState(false);

	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getVoucherTransactionsRes = useSelector(
		({ getVoucherTransactions }) => getVoucherTransactions
	);
	// console.log("getVoucherTransactionsRes", getVoucherTransactionsRes);

	const [getVoucherTransactionstatus, setGetVoucherTransactionsStatus] =
		useState(false);

	const [getVoucherTransactionListArray, setgetVoucherTransactionListArray] =
		useState([]);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "trackingId") {
			// setTrackingId(value);
			Util.verifyNumber(value)
				? setTrackingId(value)
				: setTrackingId(trackingId);
		}

		if (name === "paymentId") {
			// setPaymentId(value);
			Util.verifyNumber(value) ? setPaymentId(value) : setPaymentId(paymentId);
		}

		if (name === "customerId") {
			// setCustomerId(value);
			Util.verifyNumber(value)
				? setCustomerId(value)
				: setCustomerId(customerId);
		}

		if (name === "statusType") {
			setStatusType(value == "Select Status" ? "" : value);
		}

		if (name === "transactionType") {
			setTransactionType(value == "Select Transaction Type" ? "" : value);
		}

		if (name === "fromDateTime") {
			setfromDateTime(value);
		}

		if (name === "toDateTime") {
			settoDateTime(value);
		}
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	function filterWeekends(date) {
		return date.getDay() === 0 || date.getDay() === 6;
	}

	const getVoucherTransactionListReq = () => {
		setIsLoading(true);
		setGetVoucherTransactionsStatus(true);
		const getVoucherTransaction = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			voucherTransVO: {
				startDate: moment(selectedDate).format("DD/MM/YYYY"),
				startTime: fromDateTime,
				endDate: moment(selectedToDate).format("DD/MM/YYYY"),
				endTime: toDateTime,
				trackingId: trackingId,
				paymentId: paymentId,
				customerId: customerId,
				status: statusType,
				transactionType: transactionType
			}
		};

		return dispatch(
			getVoucherTransactionList(getVoucherTransaction, authToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			// getVoucherTransactionListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getVoucherTransactionsListRes = useSelector(
		({ getVoucherTransactions }) => getVoucherTransactions
	);

	useEffect(() => {
		if (getVoucherTransactionstatus) {
			if (getVoucherTransactionsListRes.data.status == "success") {
				setIsLoading(false);
				setgetVoucherTransactionListArray(
					[].concat(getVoucherTransactionsListRes.data.voucherTransVOList)
				);
			}
			if (getVoucherTransactionsListRes.data.status == "Failed") {
				setIsLoading(false);
				setgetVoucherTransactionListArray(getVoucherTransactionsListRes.data);
				setGetVoucherTransactionsStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherTransactionsListRes.data.status
				);
				if (
					getVoucherTransactionsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherTransactionsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherTransactionsListRes.data.status == "failed") {
				setIsLoading(false);
				setgetVoucherTransactionListArray(getVoucherTransactionsListRes.data);
				setGetVoucherTransactionsStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherTransactionsListRes.data.status
				);
				if (
					getVoucherTransactionsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherTransactionsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherTransactionsListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetVoucherTransactionListArray(getVoucherTransactionsListRes.data);
				setGetVoucherTransactionsStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherTransactionsListRes.data.status
				);
			}
		}
	}, [getVoucherTransactionsListRes.data.status]);

	useEffect(() => {
		if (getVoucherTransactionsListRes.data.status == "success") {
			setPage(0);
		}
	}, [getVoucherTransactionsListRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const sendCustomerId = (id) => {
		navigate.push({
			pathname: `/index/getVoucherTransactionDetails`,
			search: `?userId=${id}`
		});
	};

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="HH:MM:SS"
								type="tel"
								fullWidth
								value={fromDateTime}
								name="fromDateTime"
								onChange={handleChange}
								style={{ marginTop: "3px" }}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="HH:MM:SS"
								type="tel"
								fullWidth
								value={toDateTime}
								name="toDateTime"
								onChange={handleChange}
								style={{ marginTop: "3px" }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Tracking Id"
								type="text"
								fullWidth
								value={trackingId || ""}
								name="trackingId"
								onChange={handleChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Payment Id"
								type="tel"
								fullWidth
								value={paymentId}
								name="paymentId"
								onChange={handleChange}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer ID"
								type="tel"
								fullWidth
								value={customerId}
								name="customerId"
								onChange={handleChange}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Status"
								type="name"
								fullWidth
								// variant="standard"
								name="statusType"
								// value={statusType || ""}
								defaultValue={"Select Status" || statusType}
								onChange={handleChange}
							>
								<MenuItem value="Select Status" selected="Select Status">
									Select Status
								</MenuItem>
								<MenuItem value="Success">
									Success
								</MenuItem>
								<MenuItem value="Failed">Failed</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Type"
								type="name"
								fullWidth
								// variant="standard"
								name="transactionType"
								defaultValue={"Select Transaction Type" || transactionType}
								onChange={handleChange}
							>
								<MenuItem value="Select Transaction Type" selected="Select Transaction Type">
									Select Transaction Type
								</MenuItem>
								<MenuItem value="VOUCHER PURCHASE">
									VOUCHER PURCHASE
								</MenuItem>
								<MenuItem value="VOUCHER REDEEM">VOUCHER REDEEM</MenuItem>
								<MenuItem value="VOUCHER REFUND">
									VOUCHER REFUND
								</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getVoucherTransactionListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>


					{/* <Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getVoucherTransactionListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid> */}
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getVoucherTransactionListArray.length == undefined ||
					!getVoucherTransactionstatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Voucher Transaction
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText "
								>
									Voucher Transaction
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Tracking Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Status
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Amount
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Transaction Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Timestamp
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getVoucherTransactionListArray &&
											[]
												.concat(getVoucherTransactionListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.trackingId}>
														{/* <TableCell align="center">
                              <CustomButton
                                style={{
                                  marginTop: "1rem",
                                  marginLeft: "1rem",
                                }}
                                onClick={() => sendCustomerId(row.trackingId)}
                              >
                                {row.trackingId}
                              </CustomButton>
                            </TableCell> */}
														<TableCell
															align="center"
															className="themeText "
															style={{
																marginTop: "1rem",
																// marginLeft: "rem",
																// color: "#00b9f5",
																cursor: "pointer",
																fontWeight: "600"
															}}
															onClick={() => sendCustomerId(row.trackingId)}
														>
															{row.trackingId}
														</TableCell>
														<TableCell align="center">{row.status}</TableCell>
														<TableCell align="center">
															{row.customerId}
														</TableCell>
														<TableCell align="center">
															{row.amount}
														</TableCell>

														<TableCell align="center">
															{row.currency}
														</TableCell>
														<TableCell align="center">
															{row.transactionType}
														</TableCell>
														<TableCell align="center">
															{row.timestamp}
														</TableCell>
														<TableCell align="center">-</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getVoucherTransactionListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onChangePage={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>
		</>
	);
};

export default VoucherTransaction;
